import sanitizeHtml from 'sanitize-html';
import { sanitizeConfig } from '~/lib/utils/html';
const insertCleanedValue = (el, value) => {
  el.innerHTML = sanitizeHtml(value, sanitizeConfig);
};

const fadeIn = {
  created(el) {
    requestAnimationFrame(() => {
      el.classList.add('fade-in-enter');
      requestAnimationFrame(async () => {
        setTimeout(() => {
          if (el) el.classList.add('fade-in');
        }, 100);
      });
    });
  },
};

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('fade-in', fadeIn);
});
